import { jsx, jsxs } from "react/jsx-runtime";
import { COMMON_CLASSNAME } from "../../../constants.js";
function FlashFormFieldLabel(props) {
  const { fieldId, text, helperText, required } = props;
  return /* @__PURE__ */ jsx("div", { className: `${COMMON_CLASSNAME} flash-form-field-label`, children: /* @__PURE__ */ jsxs("label", { htmlFor: fieldId, className: "d-flex flex-column gap-flash-050 mb-flash-050", children: [
    /* @__PURE__ */ jsxs("span", { className: "flash-font-label-m", children: [
      text,
      required && /* @__PURE__ */ jsx("span", { className: "text-critical", children: "*" })
    ] }),
    helperText && /* @__PURE__ */ jsx("span", { className: "flash-font-body-s text-secondary", children: helperText })
  ] }) });
}
export {
  FlashFormFieldLabel as default
};
//# sourceMappingURL=FlashFormFieldLabel.js.map
